const parts = [`button`, `item`, `panel`];

const space = [8, null, 12];

const baseStyle = {
  button: {
    color: `heading`,
    px: space,
    py: 8,
  },
  container: {
    background: `white`,
    borderRadius: `lg`,
    border: 0,
    mb: 4,
    '&:last-of-type': {
      mb: 0,
    },
  },
  panel: {
    color: `heading`,
    pt: 4,
    pr: space,
    pb: 8,
    pl: space,
  },
};

export const Accordion = {
  parts,
  baseStyle,
};
